import "./css/output.css";
export default function DateValue({ label, value, className, ...props }) {
  const computedClassName = ["output", "date-value", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <div className={computedClassName} {...props}>
      {!!label && (
        <>
          <strong>{label}</strong>&nbsp;
        </>
      )}
      <span>
        {(value instanceof Date && value.toLocaleString()) ||
          new Date(value).toLocaleString()}
      </span>
    </div>
  );
}

DateValue.defaultProps = {
  className: "",
};
